module.exports = __webpack_public_path__ + "img/12.cde98ea3.png";